<template>
  <div>
    <div class="numul">
      <div v-for="(item, index) in drawList" :key="index">
        <!-- <img :class="types=='home'?'homeimg':'lotteryimg'" v-if="item" :src="lotteryimg['touzi'+item]" alt /> -->
        <div :class="index >= drawList.length - 2 ? 'blueball' : ''">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="smalltable" v-if="types == 'home'">
      <table cellpadding="0" cellspacing="0" border="0" style="
          width: 100%;
          textalign: center;
          border-top: solid 1px #e5e5e5;
          border-left: solid 1px #e5e5e5;
          text-align: center;
        ">
        <tr>
          <td style="
              border-right: solid 1px #e5e5e5;
              border-bottom: solid 1px #e5e5e5;
              color: #de0846;
            " height="30" colspan="3">
            总和
          </td>
        </tr>
        <tr>
          <td style="
              border-right: solid 1px #e5e5e5;
              border-bottom: solid 1px #e5e5e5;
            " width="140" height="30" v-for="(item, index) in drawingNumbertool" :key="index">
            {{ item }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";
import lotteryimg from "@c/lotteryimg";

export default {
  mixins: [lotteryRandBall],
  data() {
    return {
      lotteryimg,
    };
  },
  computed: {
    drawingNumbertool() {
      let tool = [];
      let { drawingNumber } = this;
      if (drawingNumber.length <= 1) {
        drawingNumber = this.randList;
      }
      if (drawingNumber) {
        let add = drawingNumber.reduce((a, b) => (a * 1) + (b * 1));
        tool.push(add);
        if (add % 2 == 0) {
          tool.push("双");
        } else {
          tool.push("单");
        }
        return tool;
      }

    },
  },
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  height: 56px;

  div {
    display: inline-block;
    box-sizing: border-box;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    background: linear-gradient(180deg, #db443c, #ff3c3c);
    box-shadow: none;
    border-color: transparent;
    margin-right: 6px;
  }

  .blueball {
    background: linear-gradient(180deg, #347ec7, #378fe7) !important;
  }
}
</style>